<div class="reportes-root">
  <!-- Grid de reportes alineados con reportTypes -->
  <section class="reportes-results">
    <div class="row">

      @for (item of appReports; track $index) {
      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="reporte-card sgd-card mat-mdc-card" (click)="openDlgReporte(item.key)">
          <mat-card-header>
            <mat-card-title class="reporte-title">
              {{item.title}}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="reporte-content">
            <div class="reporte-image">
              <img [src]="'assets/r' + ($index + 1) + '.webp'" [alt]="item.title">
            </div>
            <p class="reporte-description">
              {{item.description}}
            </p>
          </mat-card-content>
        </div>
      </div>
      }
    </div>
  </section>

  <!-- Dialog template for filters -->
  <ng-template #filterDialog>
    <div class="reportes-card sgd-card mat-mdc-card" style="padding:16px;">
      <h3 class="reportes-title">Filtros</h3>
      <form [formGroup]="form" class="reportes-form">
        <mat-form-field appearance="outline" style="width:100%">
          <mat-label>Tipo de reporte</mat-label>
          <mat-select formControlName="tipo">
            <mat-option *ngFor="let r of appReports" [value]="r.key">{{ r.title }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width:100%">
          <mat-label>Departamento</mat-label>
          <mat-select #departamentoSelect formControlName="departamento">
            <mat-option *ngFor="let d of departments" [value]="d.id">{{ d.nombre || d.descripcion || d.nombreDepartamento }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width:100%">
          <mat-label>Servidor público</mat-label>
          <mat-select formControlName="servidor">
            <mat-option *ngFor="let s of servidores" [value]="s.id">{{ s.nombre || s.displayName || s.username }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div style="display:flex;gap:8px;flex-wrap:wrap">
          <mat-form-field appearance="outline" style="flex:1;min-width:200px">
            <mat-label>Desde</mat-label>
            <input matInput [matDatepicker]="desdePicker" [max]="maxDate" formControlName="desde" placeholder="dd-MM-yyyy">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="desdePicker"></mat-datepicker-toggle>
            <mat-datepicker #desdePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" style="flex:1;min-width:200px">
            <mat-label>Hasta</mat-label>
            <input matInput [matDatepicker]="hastaPicker" [max]="maxDate" formControlName="hasta" placeholder="dd-MM-yyyy">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="hastaPicker"></mat-datepicker-toggle>
            <mat-datepicker #hastaPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="actions" style="display:flex;justify-content:flex-end;margin-top:12px">
          <button mat-stroked-button type="button" (click)="dialog.closeAll()">Cerrar</button>
          <button mat-flat-button color="primary" type="button" (click)="searchAndClose()" style="margin-left:8px">Buscar</button>
        </div>
      </form>
    </div>
  </ng-template>
</div>
